import React from 'react';
import { Box, Typography, Container, Divider } from '@mui/material';

const About: React.FC = () => {
  return (
    <Container
      maxWidth="md"
      sx={{
        marginTop: 4,
        marginBottom: 4,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
      }}
    >
      {/* Page Header OUTSIDE the box */}
      <Typography
        variant="h2"
        gutterBottom
        sx={{
          fontFamily: 'Montserrat',
          textAlign: 'center',
          color: 'dodgerblue',
        }}
      >
        About
      </Typography>
      <Divider
        sx={{
          width: '100%',                // ← full width
          borderColor: 'dodgerblue',
          borderWidth: '1px',           // thickness
          mb: 2,                        // space below
        }}
      />

        {/* Question 1 */}
        <Typography variant="h5" gutterBottom sx={{ color: 'dodgerblue' }}>
          <strong>What is APM?</strong>
        </Typography>
        <Typography variant="body1" paragraph sx={{ color: 'dodgerblue' }}>
          American Polling Machine was created to illuminate the opinions of every American. This is accomplished through daily polls covering a variety of topics.
          We feel that the opinions expressed through traditional media, social media, entertainment, and even academia have become very polarizing. Many people, regardless of background, feel their opinions are not accurately portrayed or even known to the public.
          APM provides a fun, entertaining, secure, and anonymous platform for Americans to safely share their honest opinions.
        </Typography>

        {/* Question 2 */}
        <Typography variant="h5" gutterBottom sx={{ marginTop: 3, color: 'dodgerblue' }}>
          <strong>Am I safe to share my true opinions?</strong>
        </Typography>
        <Typography variant="body1" paragraph sx={{ color: 'dodgerblue' }}>
          Yes, absolutely. As you create a profile, you are never asked your name, date of birth, or other personal identifiers. We only ask your basic demographic information. Your identity and opinions are secure.
        </Typography>

        {/* Question 3 */}
        <Typography variant="h5" gutterBottom sx={{ marginTop: 3, color: 'dodgerblue' }}>
          <strong>How is polling data used?</strong>
        </Typography>
        <Typography variant="body1" sx={{ color: 'dodgerblue' }}>
          Our dream is for many Americans to begin to share their honest opinions on a daily basis. The more opinions shared, the better our way of life will become.
          Poll result data will be publicly available to those who have polled. Demographic data will be provided to elected officials, companies, organizations, academic institutions, and many others.
          The end result will be better policies, products, offerings, and solutions, based on a much more accurate public opinion.
        </Typography>
        <Typography variant="h5" gutterBottom sx={{ marginTop: 3, color: 'dodgerblue' }}>
          <strong>Why APM?</strong>
        </Typography>
        <Box
          component="video"
          controls
          width="600"
          src="https://apm90ed.blob.core.windows.net/videos/WhyAPM.mp4?sp=r&st=2025-06-07T13:37:01Z&se=2099-06-07T21:37:01Z&spr=https&sv=2024-11-04&sr=c&sig=AIigNxlkNQjY9rwcVe7019Nt53O%2FiFFUCa1UHf2RbA0%3D"
          sx={{
            display: 'block',
            mx: 'auto',
            borderRadius: 2,
            width: '100%',
            maxWidth: 600
          }}
        />
        <Typography variant="h5" gutterBottom sx={{ marginTop: 3, color: 'dodgerblue' }}>
          <strong>Who is behind APM?</strong>
        </Typography>
        <Box
          component="video"
          controls
          width="600"
          src="https://apm90ed.blob.core.windows.net/videos/WhoIsAPM.mp4?sp=r&st=2025-06-07T13:37:01Z&se=2099-06-07T21:37:01Z&spr=https&sv=2024-11-04&sr=c&sig=AIigNxlkNQjY9rwcVe7019Nt53O%2FiFFUCa1UHf2RbA0%3D"
          sx={{
            display: 'block',
            mx: 'auto',
            borderRadius: 2,
            width: '100%',         // responsive width
            maxWidth: 600          // constrain size on large screens
          }}
        />

        <br /><br />
         <Typography variant="body1" gutterBottom sx={{ marginTop: 3, color: 'dodgerblue' }}>
          <strong>
          We will continue to enhance the APM experience each day. We invite you to poll daily, share your thoughts and feedback along the way. Please invite those you associate with to join the fun.
          <br /><br />
          Let’s Poll!
        </strong>

         </Typography>
    </Container>
  );
};

export default About;
